export default __webpack_public_path__ + "static/media/life-buoy.8ac0f836.svg";